module.exports = __webpack_public_path__ + "img/food10.a20838ba.jpg";